/// <reference path="../../types.d.ts" />
import { connect } from 'react-redux';
import { onLoad } from '../../actions/json-view';
import { setActiveProcess } from '../../actions/json-view';
import { buildDispatchable } from '../../actions/_action-utilities';
import { JSONViewApp } from './json-view-app';
import { broadcastWindowActivity } from '../../core/session-activity';

const mapStateToProps = function(state: any) {
  return { ...state.cases };
};

const mapDispatchToProps = (dispatch: any) => {
  const runDispatchable = buildDispatchable(dispatch);
  return {
    registerActivity: broadcastWindowActivity,
    onLoad: (context: CMx.Context) => {
      runDispatchable(() => {
        return dispatch(onLoad());
      });
    },
    setActiveProcess: (caseRun: CMxAPI.CaseRun) => {
      dispatch(setActiveProcess(caseRun));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JSONViewApp);
